/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Flow_System_ResolutionInputs */

const en_task_flow_system_resolution = /** @type {(inputs: Task_Flow_System_ResolutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The system relies on this resolution.`)
};

const pt_br2_task_flow_system_resolution = /** @type {(inputs: Task_Flow_System_ResolutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O sistema depende desta resolução.`)
};

/**
* | output |
* | --- |
* | "The system relies on this resolution." |
*
* @param {Task_Flow_System_ResolutionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_flow_system_resolution = /** @type {((inputs?: Task_Flow_System_ResolutionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Flow_System_ResolutionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_flow_system_resolution(inputs)
	return pt_br2_task_flow_system_resolution(inputs)
});